import { Sparkles, Star, Globe2, Handshake } from "lucide-react";

/**
 * Iter-27.62 — Badge de tier (niveau premium) pour les associations partenaires.
 *
 * 4 tiers :
 *   • signature : Partenaire Signature (or, prestige absolu)
 *   • premium   : Partenaire Premium (jaune Shariti)
 *   • impact    : Partenaire Impact (orange Shariti)
 *   • engaged   : Partenaire Engagé (blanc neutre)
 *
 * Props :
 *   - tier: "signature" | "premium" | "impact" | "engaged"
 *   - size: "sm" | "md" | "lg" (default "md")
 *   - variant: "filled" | "outline" (default "filled")
 */
const TIERS = {
    signature: {
        label: "Signature",
        icon: Sparkles,
        bg: "linear-gradient(135deg, #FFD46B 0%, #E89E2B 100%)",
        text: "#181818",
        border: "rgba(232, 158, 43, 0.6)",
    },
    premium: {
        label: "Premium",
        icon: Star,
        bg: "#FCDB53",
        text: "#181818",
        border: "rgba(252, 219, 83, 0.6)",
    },
    impact: {
        label: "Impact",
        icon: Globe2,
        bg: "linear-gradient(135deg, #EE722E 0%, #F89F63 100%)",
        text: "#FFFFFF",
        border: "rgba(238, 114, 46, 0.6)",
    },
    engaged: {
        label: "Engagé",
        icon: Handshake,
        bg: "rgba(255, 255, 255, 0.08)",
        text: "#FFFFFF",
        border: "rgba(255, 255, 255, 0.2)",
    },
};

const SIZES = {
    sm: { pad: "px-2 py-0.5", text: "text-[9px]", icon: "w-2.5 h-2.5", gap: "gap-1" },
    md: { pad: "px-2.5 py-1", text: "text-[10px]", icon: "w-3 h-3", gap: "gap-1.5" },
    lg: { pad: "px-3 py-1.5", text: "text-xs", icon: "w-3.5 h-3.5", gap: "gap-2" },
};

export default function TierBadge({ tier = "engaged", size = "md", variant = "filled" }) {
    const meta = TIERS[tier] || TIERS.engaged;
    const s = SIZES[size] || SIZES.md;
    const Icon = meta.icon;
    if (variant === "outline") {
        return (
            <span
                data-testid={`tier-badge-${tier}`}
                className={`inline-flex items-center ${s.gap} ${s.pad} rounded-full ${s.text} font-extrabold uppercase tracking-[0.18em]`}
                style={{
                    border: `1.5px solid ${meta.border}`,
                    color: meta.text,
                    background: "transparent",
                }}
            >
                <Icon className={s.icon} />
                Partenaire {meta.label}
            </span>
        );
    }
    return (
        <span
            data-testid={`tier-badge-${tier}`}
            className={`inline-flex items-center ${s.gap} ${s.pad} rounded-full ${s.text} font-extrabold uppercase tracking-[0.18em] shrink-0`}
            style={{
                background: meta.bg,
                color: meta.text,
                boxShadow: tier === "signature" ? "0 4px 18px rgba(232, 158, 43, 0.4)" : undefined,
            }}
        >
            <Icon className={s.icon} />
            Partenaire {meta.label}
        </span>
    );
}
